module.exports = __webpack_public_path__ + "img/Mutasayib_4.45b50063.jpg";